//dependencias
import React, { Component } from 'react';

//componentes
import CierreT from './cierre'

class Index extends Component {

    render(){
        return(
            <div>
                <CierreT />
            </div>
        );
    }

}
export default Index;